import Text from "../../../../styleguide/Text";
import ActionMenu from "../../../../components/actionMenu/ActionMenu";
import useRoutesHelper from "../../../../hooks/useRoutesHelper";
import userRoles from "../../../../constants/userRoles";
import usePermissions from "../../../../router/usePermissions";

function TableCustomHeader() {
  const { routeParams } = useRoutesHelper();
  const { nrauto } = routeParams as { nrauto: string };

  const { isAuthorized } = usePermissions();

  const CAR_DOCUMENT_CREATE_PERMISSION = isAuthorized(
    userRoles.CAR_DOCUMENT_CREATE,
  );

  return (
    <div className="flex items-center justify-between gap-4">
      <Text
        variant="h3"
        component="h3"
        className="mb-4 font-semibold text-slate-900"
        gutterBottom>
        Documente masina {nrauto}
      </Text>
      <ActionMenu
        items={[
          {
            id: "create-document",
            label: "Creeaza document",
            icon: "ADD",
            tooltip: "Deschide formularul pentru un document nou al masinii.",
            hidden: !CAR_DOCUMENT_CREATE_PERMISSION,
            navigate: `create?nrauto=${nrauto}`,
          },
        ]}
        title={nrauto}
        ariaLabel={`Actiuni pentru documentele masinii ${nrauto}`}
      />
    </div>
  );
}

export default TableCustomHeader;
